import { DynamicStandaloneEdge } from '@/components/Edge';
import { DynamicStandaloneStateProviders } from '@/components/StateProviders';
import { withComponentsRenderDebug } from '@/utils/withComponentsRenderDebug';
import withDevelopmentConsentCookie from '@/utils/withDevelopmentConsentCookie';
import ErrorBoundary from 'base/components/ErrorBoundary';
import { initAllerUserConsentQueue } from 'lib/utils';
import withCookiesInterceptor from 'lib/utils/withCookiesInterceptor';
import withFetchInterceptor from 'lib/utils/withFetchInterceptor';
import type { AppProps } from 'next/app';
import '../base/css/styles.css';

withComponentsRenderDebug();
withCookiesInterceptor();
withDevelopmentConsentCookie();
withFetchInterceptor();

function MyApp({ Component, pageProps }: AppProps) {
  initAllerUserConsentQueue();

  return (
    <ErrorBoundary>
      <DynamicStandaloneStateProviders {...pageProps}>
        <DynamicStandaloneEdge>
          <Component {...pageProps} />
        </DynamicStandaloneEdge>
      </DynamicStandaloneStateProviders>
    </ErrorBoundary>
  );
}

export default MyApp;
